/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type { ListImportPreviewsQueryResponse } from '../../types/ListImportPreviews'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listImportPreviews } from '../../clients/listImportPreviews'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listImportPreviewsQueryKey = () =>
  [{ url: '/api/v1/importengine/previews/v2/' }] as const

export type ListImportPreviewsQueryKey = ReturnType<
  typeof listImportPreviewsQueryKey
>

export function listImportPreviewsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listImportPreviewsQueryKey()
  return queryOptions<
    ListImportPreviewsQueryResponse,
    ResponseErrorConfig<Error>,
    ListImportPreviewsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listImportPreviews({ ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @summary List import previews for the current company
 * {@link /api/v1/importengine/previews/v2/}
 */
export function useListImportPreviews<
  TData = ListImportPreviewsQueryResponse,
  TQueryData = ListImportPreviewsQueryResponse,
  TQueryKey extends QueryKey = ListImportPreviewsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListImportPreviewsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? listImportPreviewsQueryKey()

  const query = useQuery(
    {
      ...listImportPreviewsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
